import { Controller } from 'stimulus'
import fetchClient from "../plugins/fetchClient";

export default class extends Controller {
  static targets = ['timeslotsContainer']

  connect() {
    this.serviceId = this.element.dataset.serviceId
    this.fetchTimeslots()
  }

  async fetchTimeslots() {
    this.timeslotsByClinic = await fetchClient(`/services/${this.serviceId}/nearest_clinic_timeslots`)
    this.fillContainers()
  }

  timeslotsArePresent() {
    this.timeslotsByClinic && Object.values(this.timeslotsByClinic).some(ts => { ts.length > 0 })
  }

  fillContainers() {
    this.timeslotsContainerTargets.forEach(container => {
      // container - враппер слотов, есть в модалке и в слайдере
      const clinicId = +container.dataset.clinicId
      const timeslots = this.timeslotsByClinic[clinicId]
      if (timeslots && timeslots.length > 0) {
        const timeslotDivs = container.querySelectorAll('.timeslot')
        timeslotDivs.forEach((timeSlotDiv, index) => {
          if (index < timeslots.length) {
            const span = timeSlotDiv.querySelector('span')
            span.innerText = timeslots[index]
          } else {
            timeSlotDiv.classList.add('hidden')
          }
        })
      } else {
        container.innerHTML = "<span style='line-height: 20px;'>Сейчас нет свободных окон</span>"
      }
    })
  }

  openModal() {
    const modal = document.getElementById('timeslotsModal')
    if (!modal) { return }

    const modalController = this.application
                                .getControllerForElementAndIdentifier(modal, 'modal')
    if (!modalController) { return }
    
    modalController.open()
  }
}
